<template>
  <div class="plan">
    <div class="plan__header">Мечты семейные – <br />просторная квартира</div>
    <div class="plan__main">
      <div class="plan__background"></div>
      <div class="plan__picture">
        <img
          class="plan__picture__inner"
          src="@/assets/illustrations/1/plan.png"
        />
        <!--
                <div class="plan__point" :class="['plan__point--'+($index + 1), point.visible ? 'plan__point--on-top' : '']" :key="$index" v-for="(point, $index) in points">
                    <div class="plan__point__inner">
                        <div class="plan__point__dot" @click="setVisible(point)"></div>
                        <div class="plan__popup" :class="{'plan__popup--visible': point.visible}">
                            <div class="plan__popup__close" @click="point.visible = false">
                                <span></span>
                                <span></span>
                            </div>
                            <div class="plan__popup__header">{{point.title}}</div>
                            <div class="plan__popup__text">
                                {{point.text}}
                            </div>
                        </div>
                    </div>
                </div>
                -->
      </div>
      <a
        target="_blank"
        href="https://mr-group.ru/"
        class="plan__mrgroup-logo"
        v-ga.click="
          $ga.commands.click.bind(
            this,
            'external',
            'click',
            'header_mrgroup_logo'
          )
        "
      >
        <img src="@/assets/logo-mrgroup.svg" />
      </a>
      <a
        target="_blank"
        href="https://filicity.ru/?utm_source=article&utm_campaign=june19&utm_medium=banner&utm_content=logo"
        class="plan__filicity-logo"
        v-ga.click="
          $ga.commands.click.bind(this, 'external', 'click', 'filicity_logo')
        "
      >
        <img src="@/assets/logo-filicity.png" />
      </a>

      <div class="plan__description">
        <div class="plan__description__text">
          Просторные многокомнатные квартиры в «Фили Сити» — это возможность
          выстроить жилое пространство под свои потребности. Пусть каждый решит
          для себя, что станет главным местом притяжения в квартире: большая
          гостиная, детская или личный кабинет для работы в тишине.
        </div>
        <a
          target="_blank"
          href="https://filicity.ru/?utm_source=article&utm_campaign=june19&utm_medium=banner&utm_content=1"
          class="button"
          v-ga.click="
            $ga.commands.click.bind(
              this,
              'external',
              'click',
              'chapter_1_podrobnee'
            )
          "
          >Подробнее</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      points: [
        {
          title: "Просторные окна",
          text:
            "В жилом комплексе «Фили Сити» все квартиры просторны, даже однокомнатные: все они спланированы так, чтобы пространство, воздух и свет были.",
          visible: false
        },
        {
          title: "Просторные окна",
          text:
            "В жилом комплексе «Фили Сити» все квартиры просторны, даже однокомнатные: все они спланированы так, чтобы пространство, воздух и свет были.",
          visible: false
        },
        {
          title: "Просторные окна",
          text:
            "В жилом комплексе «Фили Сити» все квартиры просторны, даже однокомнатные: все они спланированы так, чтобы пространство, воздух и свет были.",
          visible: false
        },
        {
          title: "Просторные окна",
          text:
            "В жилом комплексе «Фили Сити» все квартиры просторны, даже однокомнатные: все они спланированы так, чтобы пространство, воздух и свет были.",
          visible: false
        },
        {
          title: "Просторные окна",
          text:
            "В жилом комплексе «Фили Сити» все квартиры просторны, даже однокомнатные: все они спланированы так, чтобы пространство, воздух и свет были.",
          visible: false
        },
        {
          title: "Просторные окна",
          text:
            "В жилом комплексе «Фили Сити» все квартиры просторны, даже однокомнатные: все они спланированы так, чтобы пространство, воздух и свет были.",
          visible: false
        }
      ]
    };
  },
  methods: {
    setVisible(point) {
      this.points.forEach(pointItem => {
        pointItem.visible = false;
      });
      point.visible = true;
    }
  }
};
</script>
<style lang="stylus">
@import "~@/assets/styles/sizes.styl";
.plan
    &__mrgroup-logo
      bottom vw(-130, $desktop)
    &__filicity-logo
      bottom vw(-160, $desktop)
    &__point
        &--1
            bottom vw(120, $desktop)
            right vw(12, $desktop)
            +mobile()
                bottom vw(120, $mobile)
                right vw(12, $mobile)
        &--2
            bottom vw(100, $desktop)
            left vw(74, $desktop)
            z-index 19
            +mobile()
                bottom vw(100, $mobile)
                left vw(74, $mobile)
        &--3
            bottom vw(230, $desktop)
            right vw(60, $desktop)
            z-index 18
            +mobile()
                bottom vw(230, $mobile)
                right vw(60, $mobile)
        &--4
            bottom vw(280, $desktop)
            left vw(140, $desktop)
            z-index 20
            +mobile()
                bottom vw(280, $mobile)
                left vw(140, $mobile)
        &--5
            top vw(110, $desktop)
            right vw(68, $desktop)
            +mobile()
                top vw(110, $mobile)
                right vw(68, $mobile)
        &--6
            top vw(95, $desktop)
            left vw(145, $desktop)
            z-index 21
            +mobile()
                top vw(95, $mobile)
                left vw(145, $mobile)
</style>
